<template>
    <div class="share-file">
        <div v-if="!shareLoading" class="share-wraper">
            <div class="mint-header">
                <div class="mint-header-button is-left" @click="close">
                    <p><span class="components-icons-box"><i class="components-icons components-icons-m-left"><span class="path1"></span></i></span></p>
                </div>
                <h1 class="mint-header-title">{{$t('Mycloud')}}</h1> 
                <div class="mint-header-button is-right"></div>
            </div>
            <div class="share-header">
                <div class="file-item">
                    <div class="item-cell icon">
                        <span class="components-icons-box wps-file-icon">
                            <wps-icon class="file-ico" :type="ext"/>
                        </span>
                    </div>
                    <div class="item-cell"><p class="item-cell-name">{{fname.replace(`.${ext}`,'')}}</p></div>
                </div>
            </div>
            <div class="share-transition"></div>
            <div class="share-inner">
                <div class="share-per-item" @click="switchTab('anyone-view')">
                    <div>{{$t('Anyone')}}<span v-if="viewMode == 'anyone-view'" class="components-icons-box"><i class="components-icons components-icons-m-check"><span class="path1"></span></i></span></div>
                </div>
                <div v-if="editable" class="share-per-item" @click="switchTab('anyone-edit')">
                    <div>{{$t('Anyedit')}}<span v-if="viewMode == 'anyone-edit'" class="components-icons-box"><i class="components-icons components-icons-m-check"><span class="path1"></span></i></span></div>
                </div>
                <div class="share-per-item" @click="switchTab('')">
                    <div>{{$t('Stopshare')}}</div>
                </div>
                <div class="share-inner-foot">
                    <button v-clipboard="copyData" @success="copySuccess" @error="copyError" class="mint-button mint-button--primary mint-button--normal"><label class="mint-button-text">{{$t('Copy')}}</label></button>
                </div>
            </div>
        </div>
        <div class="share-wraper" v-if="shareLoading" >
            <loading />
        </div>
    </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import {share} from '@/store/service/index'
import {updateShare,getMembers,switchPermission,removeMember,getPermission} from '@/store/service/share'
import {editable} from '@/config'
import Loading from '@/components/Loading'
export default {
    data(){
        return {
            copyData: '',
            shareLoading: true,
            error: '',
            viewMode: '',
            expire: 3,
            Onshare: false,
            members: []
        }
    },
    components:{
        Loading
    },
    created(){
        this.doShare()
    },
    computed:{
        ...mapState('preview',[
            'fname',
            'groupid'
        ]),
        ext(){
            let name = this.fname
            return name.slice(name.lastIndexOf('.') + 1) || ''
        },
        mode(){
            let mode = {
                "anyone-view": this.$t('Anyone'),
                "anyone-edit": this.$t('Anyedit'),
                "specific-access": this.$t('Someone')
            }
            return mode[this.viewMode]
        },
        expireDate(){
            let dates = [3,7,30,0]
            return dates[this.expire]
        },
        editable(){
            return editable.indexOf(this.ext.toLowerCase()) > -1
        }
    },
    methods:{
        ...mapActions('index',[
            'share'
        ]),
        ...mapMutations([
            'SHOW_DIALOG',
            'DIALOG_INIT'
        ]),
        ...mapActions([
            'close'
        ]),
        switchTab(e){
            if (e == this.viewMode) {
                return
            }
            if (e) {
                this.viewMode = e
                let {$route:{params:{fileid}},groupid} = this
                updateShare({
                    fileid,groupid,access_mode: this.viewMode,validity_term: this.expireDate
                },({status,data}) => {
                    if (status >= 200 && status < 300) {
                        if (this.viewMode == 'specific-access') {
                        }
                        this.$message.success('Success')
                    }else{
                        this.$message.error(this.$t(data.result))
                    }
                })
            }else{
                
                let {dialogData,viewMode,expire,copyData,dialogIco,dialogTitle,editable} = this
                this.SET_EXTRA({
                    editable
                })
                this.SHOW_DIALOG({
                    title: this.$t('Stopshare'),
                    confirmInfo: this.$t('Stoptip'),
                    current: 'Confirm',
                    smodule: 'index',
                    action: 'stopShare',
                    dialogData: {
                        ...dialogData,
                        dialogIco,
                        dialogTitle,
                        viewMode,expire,copyData,
                        confirmtxt: this.$t('Stopshare'),
                        close: this.back
                    }
                })
            }
            
        },
        copySuccess(e){
            this.$message.success(this.$t('Copylink'))

        },
        copyError(){
            this.$message.success(this.$t('Copyerror'))
        },
        async doShare(){
            let {$route:{params:{fileid}},groupid} = this
            let result = await new Promise((resolve) => {
                share({
                    fileid,
                    groupid
                },(res) => {
                    resolve(res)
                })
            })
            if (result.status >= 200 && result.status < 300) {
                let dates = [3,7,30,0]
                this.expire = dates.indexOf(result.data.validity_term)
                this.copyData = result.data.share_link
                this.viewMode = result.data.access_mode
                _dw.onEvent('drive_fileaction_share',{
                    type: 'success'
                })
            }else{
                _dw.onEvent('drive_fileaction_share',{
                    type: 'failed',
                    result: result.data.result
                })
                this.$message.error(this.$t(result.data.result))
                this.close()
            }
            this.shareLoading = false
        }
    }
}
</script>

<style>
.mint-header {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    line-height: .88rem;
    position: relative;
    text-align: center;
    white-space: nowrap;
    padding: 0 .23rem;
    background: #fff;
    color: #999;
    font-size: .26rem;
    height: .88rem;
    flex: none;
    border-bottom: 1px solid #e5e5e5;

}
.mint-header-button.is-left {
    text-align: left;
}
.mint-header p {
    line-height: .96rem;
}
.mint-header-button {
    flex: .5;
}
.mint-header i {
    display: inline-block;
    vertical-align: top;
    line-height: .6rem;
    width: .6rem;
    margin-top: .18rem;
    font-size: .4rem;
    color: #030303;
}
.mint-header .mint-header-title {
    font-size: .36rem;
    color: #030303;
    line-height: .88rem;
    font-weight: normal;
    flex: 1;
}
.mint-header-button.is-right {
    text-align: right;
}
.share-header {
    display: table;
    width: 100%;
    padding-left: .3rem;
}
.file-item{
    display: table-row;
    width: 100%;
    height: 1.35rem;
    padding-right: .2rem;
}
.share-header .item-cell {
    border-bottom: 0;
}
.share-header .item-cell-name {
    font-size: .32rem;
    color: #353535;
}
.file-item .item-cell.icon, .member-item .item-cell.icon {
    width: 1.04rem;
    font-size: .6rem;
    padding-right: 0;
}
.file-item .item-cell, .member-item .item-cell {
    position: relative;
    display: table-cell;
    vertical-align: middle;
    font-size: .28rem;
    padding-right: .2rem;
}
.share-transition {
    height: .4rem;
    background: #f5f5f5;
}
.share-inner .share-per-item {
    margin-left: .3rem;
    position: relative;
    line-height: 1.36rem;
    border-bottom: 1px solid #e6e6e6;
    font-size: .32rem;
    color: #171717;
}
.share-inner .share-per-item i {
    position: absolute;
    color: #2e68f8;
    font-size: .36rem;
    right: .2rem;
    top: .5rem;
}
.share-inner .share-inner-foot {
    position: absolute;
    width: 100%;
    bottom: .3rem;
    padding: 0 .4rem;
    box-sizing: border-box;
}
.share-inner .share-inner-foot button {
    width: 100%;
    background: #2e68f8;
    height: .96rem;
    line-height: .96rem;
    color: #fff;
    appearance: none;
    border-radius: 4px;
    border: 0;
    box-sizing: border-box;
    display: block;
    font-size: 18px;
    outline: 0;
    overflow: hidden;
    position: relative;
    text-align: center;
}
.el-message{
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/file/Mshare.vue